export default function ({state, getters, rootState, dispatch}, value) {
    const form = rootState.subsidies.item.form;
    let item = state.PaymentDetails.filter(i => {
        return i.Code === value;
    })[0];

    window.app.$modal('agreement_pay', {
        code: value,
        item,
        currency: form.CurrencyId,
        max: getters.sumMax,
        change: data => {
            if (!item) {
                state.PaymentDetails.push(data);
            } else {
                for (let k in data) {
                    item[k] = data[k];
                }
            }
            dispatch('save');
        }
    })
}
